import {BoxesToolboxOptions, PageBox, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum BoxesFunction {
	EDIT = "edit",
	REMOVE = "remove"
}

export class PortalBoxesToolboxOptions extends BoxesToolboxOptions implements Parameter {
	public mode?: BoxesFunction;
	public type?: PageBox;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : BoxesFunction.EDIT;
		this.type = FunctionHelper.exists(data?.type) ? data.type : PageBox.CropBox;
	}

	public static getModeDefault(): BoxesFunction {
		return BoxesFunction.EDIT;
	}

	public static getTypeDefault(): PageBox {
		return PageBox.CropBox;
	}

	public static fromJson(data: any): PortalBoxesToolboxOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalBoxesToolboxOptions(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode,
			'type': this.type
		};
	}

	public clone(): PortalBoxesToolboxOptions {
		return PortalBoxesToolboxOptions.fromJson(this.toJson());
	}
}